import { ErrorStrings } from '../constants/fixedMessages';
import { handleError } from 'services/ErrorService/ErrorService';
import { HISTORICAL_TICKET_ORIGIN_SIMPLR } from '../constants/historicalTicketOrigins';
import { processAssignedTicket } from '../util/dataObjectToStoreObject';
import makeCloudFunctionRequest from './makeCloudFunctionRequest';

function createHistoricalTicketsResponse(tickets = []) {
  return {
    tickets: Array.isArray(tickets) ? tickets : [],
    totalCount: Array.isArray(tickets) ? tickets.length : 0,
  };
}

export const fetchPastTicketsOnSameChannel = async (selectedTicket, platformDomain) => {
  if (!selectedTicket) {
    handleError({ customMessage: ErrorStrings.SELECTED_TICKET_NOT_FOUND });

    return { tickets: [], totalCount: 0 };
  }

  let response;

  try {
    // TODO: Refactor to makeCloudFunctionRequest when there is no need for tickets to be Parse objects
    response = await makeCloudFunctionRequest('getHistoricalConversations', {
      selectedTicket,
      platformDomain,
    });
  } catch (error) {
    handleError({ error, showPopup: true });
  }

  response = response || {};

  const { tickets, origin } = response;

  if (!Array.isArray(tickets)) {
    return createHistoricalTicketsResponse();
  }

  if (origin === HISTORICAL_TICKET_ORIGIN_SIMPLR) {
    const processedTickets = tickets.map(processAssignedTicket);

    return createHistoricalTicketsResponse(processedTickets);
  }

  return createHistoricalTicketsResponse(tickets);
};
